import React, { Component, Fragment } from 'react';
import { Button, Col, Collapse, Divider, Empty, Row, Select, Form } from 'antd';
import { ActionsMenu } from './ActionsMenu';
import { inject, observer } from 'mobx-react';
import { Actions } from './actions';
const Panel = Collapse.Panel;
const Option = Select.Option;

@inject('store')
@observer
export class ActionPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openActions: false
        };
    }

    handleAddAction(mode, item) {
        this.props.store.botStore.triggerStore.addAction(mode, this.props.triggerId, item);
    }

    render() {
        const { mode } = this.props;

        return (
            <Fragment>
                <Divider orientation={'left'}>Actions</Divider>

                {this.renderCollapse(mode)}

                <ActionsMenu
                    onSelect={this.handleAddAction.bind(this, mode)}
                    visible={this.state.openActions}
                    onCancel={() => this.setState({ openActions: false })}
                />
            </Fragment>
        );
    }

    renderCollapse() {
        const { trigger, mode } = this.props;

        if (trigger[`${mode}_actions`] && trigger[`${mode}_actions`].length) {
            return (
                <Fragment>
                    <Collapse>
                        {trigger[`${mode}_actions`].map((action, i) => {
                            const inputs = Actions[action.id].inputs;

                            return (
                                <Panel header={action.name} key={i}>
                                    <Row gutter={24}>
                                        {inputs.map((input, x) => {
                                            let options = [];

                                            if (input.options) {
                                                const opts =
                                                    typeof input.options === 'function'
                                                        ? input.options()
                                                        : input.options;
                                                options = opts.map(o => (
                                                    <Option key={o.id} id={o.id}>
                                                        {o.name}
                                                    </Option>
                                                ));
                                            }

                                            return (
                                                <Col md={12} key={x}>
                                                    <Form.Item label={input.label}>
                                                        <input.component
                                                            value={action[input.name]}
                                                            defaultValue={input.default}
                                                            style={{ width: '100%' }}
                                                            onChange={e => {
                                                                const value =
                                                                    (e.target && e.target.value) ||
                                                                    e;
                                                                this.props.store.botStore.triggerStore.updateAction(
                                                                    mode,
                                                                    this.props.triggerId,
                                                                    i,
                                                                    input.name,
                                                                    value
                                                                );
                                                            }}
                                                        >
                                                            {options}
                                                        </input.component>
                                                    </Form.Item>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                    <div style={{ textAlign: 'right', padding: 10 }}>
                                        <Button
                                            onClick={() =>
                                                this.props.store.botStore.triggerStore.removeAction(
                                                    mode,
                                                    this.props.triggerId,
                                                    i
                                                )
                                            }
                                            type={'danger'}
                                        >
                                            Remove Action
                                        </Button>
                                    </div>
                                </Panel>
                            );
                        })}
                    </Collapse>
                    <Button
                        type={'primary'}
                        block
                        style={{ marginTop: 10 }}
                        onClick={() => this.setState({ openActions: true })}
                    >
                        Add Action
                    </Button>
                </Fragment>
            );
        }

        return (
            <Empty description={<span>Add actions to create automation workflows</span>}>
                <Button
                    type={'primary'}
                    style={{ marginTop: 10 }}
                    onClick={() => this.setState({ openActions: true })}
                >
                    Add Action
                </Button>
            </Empty>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/TriggerView/ActionPanel.js